import { useGeoCountriesMasterdataQuery } from "@/features/masterdata/queries/geo-countries-masterdata-query";

export function useGeoCountriesMasterdata() {
  const geoCountriesQuery = useGeoCountriesMasterdataQuery();

  const geoCountries = computed(() => geoCountriesQuery.data.value || []);

  function getCountryByCode(code: string) {
    const country = geoCountries.value.find((el) => el.iso_code_alpha2.toUpperCase() === code.toUpperCase());
    if (!country) {
      throw new Error(`Could not find any country with code ${code} in master data store.`);
    }
    return country;
  }

  function getCountryNameByCode(code?: string) {
    try {
      if (code) {
        return getCountryByCode(code)?.name;
      }
      return "";
    } catch (error) {
      console.error(error);
      return "";
    }
  }

  return {
    geoCountries,
    getCountryByCode,
    getCountryNameByCode,
    isLoading: geoCountriesQuery.isLoading,
    error: geoCountriesQuery.error,
    refetch: geoCountriesQuery.refetch,
  };
}
